"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";

export function usePaginationQuery(searchParams: Record<string, unknown>) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const handlePageChange = (_: unknown, newPage: number) => {
    const params = new URLSearchParams(Object.entries(searchParams || {}) as [string, string][]);

    params.set("page", String(newPage + 1));

    startTransition(() => {
      router.push(`?${params.toString()}`, { scroll: false });
    });
  };

  const handlePageSizeChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const params = new URLSearchParams(Object.entries(searchParams || {}) as [string, string][]);

    params.set("size", event.target.value);
    params.set("page", "1");

    startTransition(() => {
      router.push(`?${params.toString()}`, { scroll: false });
    });
  };

  return {
    handlePageChange,
    handlePageSizeChange,
    isPending,
    startTransition,
  };
}
